<template>
  <!-- IFrame provided by bunny.cdn -->
  <div style="position: relative; padding-top: 56.25%">
    <iframe
      :src="iFrameVideoUrl"
      loading="lazy"
      style="
        border: none;
        position: absolute;
        top: 0;
        height: 100%;
        width: 100%;
      "
      allow="accelerometer; gyroscope; encrypted-media; picture-in-picture;"
      allowfullscreen="true"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "VideoLink",
  components: {},
  props: {
    iFrameVideoUrl: String,
  },
  data() {
    return {};
  },
};
</script>
